/* unplugin-vue-components disabled */import { render } from "./Login.vue?vue&type=template&id=5850f3a1&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=5850f3a1&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\orc_wt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5850f3a1"]])

export default __exports__